import { Controller } from 'stimulus'

export default class SearchController extends Controller {
  static targets = ['stringToSearch']

  search() {
    const value = this.stringToSearchTarget.value
    window.location.href = `?search=${value}`
    return true
  }

  keypress(event) {
    if (event.key === "Enter")
      return this.search()
    return false
  }
}
